import React from "react";
import Image from "components/image";
import getContainerSizeClass from "@root/helpers/get-container-size-class";

const ImageBlock = ({ data }) => {
    if (!data?.image?.asset && !data?.image?._ref) return null;

    const containerClasses = data?.moduleSettings ? getContainerSizeClass(data.moduleSettings) : [];
    const objectFit = data?.objectFit || "cover";
    const aspectRatio = data?.aspectRatio || "auto";
    const alignment = data?.alignment || "center";
    const width = data?.width || "full";
    const borderRadius = data?.borderRadius || "medium";

    const alignmentClass = `image-block--align-${alignment}`;
    const widthClass = `image-block--width-${width}`;
    const borderRadiusClass = `image-block--radius-${borderRadius}`;
    const objectFitClass = `image-block__image--${objectFit}`;

    const wrapperStyle = {};
    if (aspectRatio !== "auto") {
        wrapperStyle.aspectRatio = aspectRatio.replace("/", " / ");
    }

    const imageElement = (
        <Image
            image={data.image}
            alt={data.alt || "Image"}
            to={data.url}
            className={`image-block__image ${objectFitClass}`}
        />
    );

    return (
        <div className={`image-block ${alignmentClass} ${widthClass} ${borderRadiusClass} ${containerClasses.join(" ")}`}>
            <div className="image-block__wrapper" style={wrapperStyle}>
                {imageElement}
            </div>
            {data?.caption && (
                <div className="image-block__caption">{data.caption}</div>
            )}
        </div>
    );
};

export default ImageBlock;
